<template>
  <v-content class="mx-4">
    <v-layout>
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">แดชบอร์ด</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281" @click="$router.push('/manage-user-accounts').catch(err => {})">สถิติ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          สถิติ
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
        <v-layout>
          <v-flex shrink mr-4>
            <span style="font-size: 20px;font-weight: bold;">สรุปภาพรวมการทำงาน  </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout mt-1>
      <v-flex xs12>
        <v-layout justify-center>
          <v-flex xs2 pa-2 style="background-color: #527281; color: white;">
            <div style="font-weight: bold; font-size: 14px;">ผู้ใช้งานระบบ <br/>ประจำวันนี้</div>
            <div style="font-weight: bold;font-size: 14px;"><span style="font-size: 24px;">{{number_login_today}}</span> คน</div>
          </v-flex>
          <v-flex xs1 pa-2 mr-1 pt-4 style="background-color: #84A2A8;">
            <v-icon style="font-size: 60px; color: #fff;">public</v-icon>
          </v-flex>

          <v-flex xs2 pa-2 style="background-color: #527281; color: white;">
            <div style="font-weight: bold; font-size: 14px;">จำนวนการสืบค้น <br>ประจำวันนี้</div>
            <div style="font-weight: bold;font-size: 14px;"><span style="font-size: 24px;">{{number_search_today}}</span> คน</div>
          </v-flex>
          <v-flex xs1 pa-2 mr-1 pt-4 style="background-color: #84A2A8;">
            <v-icon style="font-size: 60px; color: #fff;">search</v-icon>
          </v-flex>

          <v-flex xs2 pa-2 style="background-color: #527281; color: white;">
            <div style="font-weight: bold; font-size: 14px;">จำนวนสั่งพิมพ์เพื่อดู<br/> ประจำวันนี้</div>
            <div style="font-weight: bold;font-size: 14px;"><span style="font-size: 24px;">{{number_view_today}}</span> คน</div>
          </v-flex>
          <v-flex xs1 pa-2 mr-1 pt-4 style="background-color: #84A2A8;">
            <v-icon style="font-size: 60px; color: #fff;">description</v-icon>
          </v-flex>

          <v-flex xs2 pa-2 style="background-color: #527281; color: white;">
            <div style="font-weight: bold; font-size: 14px;">จำนวนสั่งพิมพ์เพื่อจัดซื้อ<br/> ประจำวันนี้</div>
            <div style="font-weight: bold;font-size: 14px;"><span style="font-size: 24px;">{{number_print_today}}</span> คน</div>
          </v-flex>
          <v-flex xs1 pa-2 mr-1 pt-4 style="background-color: #84A2A8;">
            <v-icon style="font-size: 60px; color: #fff;">local_printshop</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <loading :active.sync="isLoading"></loading>
    <v-layout>
      <v-flex my-4>
        <!-- Bar Chart -->
        <v-card class="px-6 pt-4 pb-6 mb-6 bar-chart">
<!--          <loading :active.sync="isLoading"></loading>-->
          <v-layout>
            <v-flex mb-6 style="text-align: left; color: #527281;">
              <span @click="getDataSearchTools()">สถิติการใช้งานสืบค้น จำแนกรายทัพภาค</span>
            </v-flex>
            <v-flex xs3 mb-6 style="text-align: right; color: #527281;">
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                background-color="#E5E5E5"
                solo
                flat
                v-model="organization_id"
                :items="organitzation"
                item-text="organization_name"
                item-value="organization_id"
                label="-- กรุณาเลือกทัพภาค --"
                @change="getDataOrganizationSearchTools"
                required
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <BarChart
                v-if="barLoaded"
                :chartdata="dataSearchBarChart"
                :options="amountStatSearchBarChart"
                dataname="Value"
              ></BarChart>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- Bar Chart Horizontal -->
        <v-card class="px-6 pt-4 pb-6 mb-6 bar-chart search-Data-Form">
          <v-layout>
            <v-flex mb-6 style="text-align: left; color: #527281;">
              <span>สถิติการจัดลำดับการสืบค้นของหน่วยสายแพทย์ ตามช่วงเวลาที่กำหนด</span>
            </v-flex>
            <v-flex style="text-align: right;color: #527281;">
              <span>วัน/เวลา ระหว่าง :</span>
            </v-flex>
            <v-flex xs2 mr-2>
              <v-menu
                v-model="dateBarHchartStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    background-color="#E5E5E5"
                    hide-details
                    v-model="barHChartDateStart"
                    single-line
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="barHChartDateStart"
                  @input="dateBarHchartStart = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex shrink mt-1 mr-2>
              ถึง:
            </v-flex>
            <v-flex xs2>
              <v-menu
                v-model="dateBarHchartEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    background-color="#E5E5E5"
                    hide-details
                    v-model="barHChartDateEnd"
                    single-line
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="barHChartDateEnd"
                  @input="dateBarHchartEnd = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-btn @click="onclickSearchDateChart" style="border-radius: 50px; height: 30px;background-color: #527281; color: white">
                ค้นหา
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex>
              <BarChartHorizontal
                class="mb-5"
                v-if="barHorizLoaded"
                :chartdata="dataSearchBarHChart"
                :options="amountStatSearchBarHChart"
              ></BarChartHorizontal>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- Pie Chart -->
        <v-layout class="search-Data-Form" justify-cente>
          <!-- Pie Chart สถิติการจัดลำดับการสืบค้นของกลุ่มอุปกรณ์ ตามช่วงเวลา -->
          <v-flex xs6 mr-1>
            <v-card class="pa-4 mb-6 pie-chart">
              <v-layout mb-4 style="text-align: left;color: #527281;">
                <v-flex>
                  <span>สถิติการจัดลำดับการสืบค้นของกลุ่มอุปกรณ์ ตามช่วงเวลา</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex mt-1 style="text-align: right;color: #527281;">
                  <span>วัน/เวลา ระหว่าง :</span>
                </v-flex>
                <v-flex xs3 mr-2>
                  <v-menu
                    v-model="dateGroupPieChartStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#E5E5E5"
                        hide-details
                        v-model="pieGroupChartDateStart"
                        single-line
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pieGroupChartDateStart"
                      @input="dateGroupPieChartStart = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex shrink mt-1 mr-2 style="color: #527281;">
                  ถึง:
                </v-flex>
                <v-flex xs3>
                  <v-menu
                    v-model="dateGroupPieChartEnd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#E5E5E5"
                        hide-details
                        v-model="pieGroupChartDateEnd"
                        single-line
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pieGroupChartDateEnd"
                      @input="dateGroupPieChartEnd = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <v-btn @click="onclickSearchGroupPieChart" style="border-radius: 50px; height: 30px;background-color: #527281; color: white">
                    ค้นหา
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout mt-6 justify-center>
                <v-flex ml-12>
                  <pie-chart
                    style="width: 300px; height: 300px"
                    v-if="pieGroupLoaded"
                    :chartdata="dataPieChart1"
                  >
                  </pie-chart>
                </v-flex>
                <v-flex mt-6>
                  <v-layout v-for="item in dataNameGroup" mb-2>
                    <v-flex shrink mr-1>
                      <div class="square" :style="{'background-color': item.color}"></div>
                    </v-flex>
                    <v-flex xs10 style="text-align: left;font-size: 11px;">
                      {{item.text}}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card>
          </v-flex>
          <!-- Pie Chart สถิติการจัดลำดับการสืบค้นของสิ่งอุปกรณ์ ตามช่วงเวลา -->
          <v-flex xs6 ml-1>
            <v-card class="pa-4 mb-6 pie-chart">
              <v-layout mb-4 style="text-align: left;color: #527281;">
                <v-flex>
                  <span>สถิติการจัดลำดับการสืบค้นของสิ่งอุปกรณ์ ตามช่วงเวลา</span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex mt-1 style="text-align: right;color: #527281;">
                  <span>วัน/เวลา ระหว่าง :</span>
                </v-flex>
                <v-flex xs3 mr-2>
                  <v-menu
                    v-model="dateToolPieChartStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#E5E5E5"
                        hide-details
                        v-model="pieToolChartDateStart"
                        single-line
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pieToolChartDateStart"
                      @input="dateToolPieChartStart = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex shrink mt-1 mr-2 style="color: #527281;">
                  ถึง:
                </v-flex>
                <v-flex xs3>
                  <v-menu
                    v-model="dateToolPieChartEnd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        background-color="#E5E5E5"
                        hide-details
                        v-model="pieToolChartDateEnd"
                        single-line
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pieToolChartDateEnd"
                      @input="dateToolPieChartEnd = false"
                      locale="th"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <v-btn @click="onclickSearchToolsPieChart" style="border-radius: 50px; height: 30px;background-color: #527281; color: white">
                    ค้นหา
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout mt-6>
                <v-flex ml-12>
                  <pie-chart
                    style="width: 300px; height: 300px"
                    v-if="pieToolLoaded"
                    :chartdata="dataPieChart2"
                  >
                  </pie-chart>
                </v-flex>

                <v-flex mt-6 style="">
                  <v-layout v-for="item in dataNameTools" mb-2>
                    <v-flex shrink mr-1>
                      <div class="square" :style="{'background-color': item.color}"></div>
                    </v-flex>
                    <v-flex xs10 style="text-align: left;font-size: 11px;">
                      {{item.text}}
                    </v-flex>
                  </v-layout>
                </v-flex>

              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-content>

</template>

<script>
    import BarChartHorizontal from "../components/BarChartHorizontal";
    import BarChart from "../components/BarChart";
    import PieChart from "../components/PieChart";
    import Service from "../service";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    // import Common from "../service/api/CommonAPI";
    // import { mapState } from "vuex";

    export default {
        components: {
            BarChart,
            BarChartHorizontal,
            PieChart,
            Loading
        },
        name: "Dashboard",
        computed: {
        },
        data: () => ({
            barLoaded: false,
            barHorizLoaded: false,
            pieGroupLoaded: false,
            pieToolLoaded: false,
            isLoading: true,

            // Dashboad
            number_login_today: 0,
            number_search_today: 0,
            number_view_today: 0,
            number_print_today: 0,

            tab: 1,
            organization_id:'',
            organitzation: [],
            dataSearchBarChart: [],
            amountStatSearchBarChart: [],

            //Data Bar Horizontal
            barHChartDateStart: new Date().toISOString().substr(0, 10),
            barHChartDateEnd: new Date().toISOString().substr(0, 10),
            dateBarHchartStart: false,
            dateBarHchartEnd: false,
            dataSearchBarHChart: [],
            amountStatSearchBarHChart: [],

            //Data Pie Chart 1
            pieGroupChartDateStart: new Date().toISOString().substr(0, 10),
            pieGroupChartDateEnd: new Date().toISOString().substr(0, 10),
            dateGroupPieChartStart: false,
            dateGroupPieChartEnd: false,

            dataPieChart1: {
                hoverBackgroundColor: "red",
                hoverBorderWidth: 10,
                labels: [],
                datasets: [
                    {
                        label: "Search order ranking statistics for device groups",
                        backgroundColor: [
                            "#3d68cc",
                            "#eb7134",
                            "#e0dcda",
                            "#f0cc2b",
                            "#89bad6",
                            "#40cf53",
                            "#333482",
                            "#ba6036",
                            "#8c8c8c",
                            "#948653",
                        ],
                        data: []
                    }
                ]
            },
            colorGroup: [
                "#3d68cc",
                "#eb7134",
                "#e0dcda",
                "#f0cc2b",
                "#89bad6",
                "#40cf53",
                "#333482",
                "#ba6036",
                "#8c8c8c",
                "#948653",
            ],
            dataNameGroup: [],

            //Data Pie Chart 2
            pieToolChartDateStart: new Date().toISOString().substr(0, 10),
            pieToolChartDateEnd: new Date().toISOString().substr(0, 10),
            dateToolPieChartStart: false,
            dateToolPieChartEnd: false,

            dataPieChart2: {
                hoverBackgroundColor: "red",
                hoverBorderWidth: 10,
                labels: [],
                datasets: [
                    {
                        label: "Search order ranking statistics for device groups",
                        backgroundColor: [
                            "#3d68cc",
                            "#eb7134",
                            "#e0dcda",
                            "#f0cc2b",
                            "#89bad6",
                            "#40cf53",
                            "#333482",
                            "#ba6036",
                            "#8c8c8c",
                            "#948653",
                        ],
                        data: []
                    }
                ]
            },
            dataNameTools: [],
        }),
        created() {
            this.pageLoaded();
        },
        methods: {
            pageLoaded() {
                this.getDataSearchTools();
                this.showOrganization();
                this.getStatSearchOrganization();
                this.getStatSearchGroupMeds();
                this.getStatSearchGroupTools();
                this.getNumberSearchingToday();
                this.getNumberViewToday();
                this.getNumberPrintingToday();
                this.getNumberLoginToday();
            },

            // Get Number ToDay
            getNumberLoginToday() {
                Service.Common.getNumberLoginToday().then(data => {
                    // console.log(data, 'login')
                    this.number_login_today = data;
                })
            },
            getNumberSearchingToday() {
                Service.Common.getNumberSearchingToday().then(data => {
                    this.number_search_today = data;
                })
            },
            getNumberViewToday() {
                Service.Common.getNumberViewToday().then(data => {
                    // console.log('View: ', data)
                    this.number_view_today = data;
                })
            },
            getNumberPrintingToday() {
                Service.Common.getNumberPrintingToday().then(data => {
                    // console.log('Print: ', data)
                    this.number_print_today = data;
                })
            },

            // Get Organization
            showOrganization() {
                Service.Organization.showOrganization().then(res => {
                    // console.log(data)
                    res.data.forEach(dataOrganitzation => {
                        this.organitzation.push({
                            organization_id: `${dataOrganitzation.id}`,
                            organization_name: `${dataOrganitzation.name}`
                        });
                    })
                })
            },

            // Bar Chart
            getDataSearchTools() {
                this.isLoading = true;
                this.barLoaded = false;
                Service.Common.getDataSearchTools().then(data => {
                    // console.log(data)
                    data.forEach(data_tool => {
                        let name = data_tool.name_th.substring(0,25)+'...';
                        this.dataSearchBarChart.push(name)
                        this.amountStatSearchBarChart.push(data_tool.count)
                    })
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.barLoaded = true;
                    });
                });
            },
            getDataOrganizationSearchTools(id) {
                // console.log(id)
                this.dataSearchBarChart = [];
                this.amountStatSearchBarChart = [];
                this.barLoaded = false;
                this.isLoading = true;
                Service.Common.getDataOrganizationSearchTools({id:id}).then(data => {
                    // console.log(data)
                    data.forEach(data_tool => {
                        let name = data_tool.name_th.substring(0,25)+'...';
                        this.dataSearchBarChart.push(name)
                        this.amountStatSearchBarChart.push(data_tool.count)
                    })
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.barLoaded = true;
                    }, 300);
                });
            },

            //Bar Chart Horizontal
            getStatSearchOrganization() {
                this.barHorizLoaded = false;
                this.isLoading = true;
                Service.Common.getStatSearchOrganization().then(data => {
                    // console.log('Bar Chart Horizontal ',data)
                    data.forEach(data_stat_organize => {
                        this.dataSearchBarHChart.push(data_stat_organize.name)
                        this.amountStatSearchBarHChart.push(data_stat_organize.count)
                    })
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.barHorizLoaded = true;
                    }, 300);
                });
            },
            onclickSearchDateChart() {
                this.barHorizLoaded = false;
                this.isLoading = true;
                let data_date = {
                    start_date: this.barHChartDateStart,
                    end_date: this.barHChartDateEnd,
                }
                this.dataSearchBarHChart = [];
                this.amountStatSearchBarHChart = [];
                Service.Common.getStatSearchDateOrganization(data_date).then(data => {
                    data.forEach(data_stat_organize => {
                        this.dataSearchBarHChart.push(data_stat_organize.name)
                        this.amountStatSearchBarHChart.push(data_stat_organize.count)
                    })
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.barHorizLoaded = true;
                    }, 300);
                });
            },

            // Pie Chart
            getStatSearchGroupMeds() {
                this.isLoading = true;
                this.pieGroupLoaded = false;
                Service.Common.getStatSearchGroupMeds().then(data => {
                    data.forEach((data_group_med, index) => {
                        this.dataPieChart1.labels.push(data_group_med.main_group_desc)
                        let name = data_group_med.main_group_desc.substring(0,30)+'...';
                        this.dataNameGroup.push({ text: name, color: this.colorGroup[index] })
                        this.dataPieChart1.datasets[0].data.push(data_group_med.count)
                    })
                    // console.log( this.dataNameGroup)
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.pieGroupLoaded = true;
                    });
                });

            },
            getStatSearchGroupTools() {
                this.isLoading = true;
                this.pieToolLoaded = false;
                let data_date = {
                    start_date: this.barHChartDateStart,
                    end_date: this.barHChartDateEnd,
                }
                Service.Common.getDataSearchTools(data_date).then(data => {
                    data.forEach((data_group, index) => {
                        this.dataPieChart2.labels.push(data_group.name_th)
                        let name = data_group.name_th.substring(0,30)+'...';
                        this.dataNameTools.push({ text: name,color: this.colorGroup[index] })
                        this.dataPieChart2.datasets[0].data.push(data_group.count)
                    });
                    setTimeout(() => {
                        this.isLoading = false;
                        this.pieToolLoaded = true;
                    },300)
                })
            },

            onclickSearchGroupPieChart() {
                this.isLoading = true;
                this.pieGroupLoaded = false;
                let data_date = {
                    start_date: this.pieGroupChartDateStart,
                    end_date: this.pieGroupChartDateEnd,
                }
                this.dataPieChart1.labels = [];
                this.dataNameGroup = [];
                this.dataPieChart1.datasets[0].data = [];
                // console.log('Group', data_date)
                Service.Common.getStatSearchDateGroup(data_date).then(data => {
                    // console.log(data)
                    data.forEach((data_group_med, index) => {
                        this.dataPieChart1.labels.push(data_group_med.main_group_desc);
                        let name = data_group_med.main_group_desc.substring(0,30)+'...';
                        this.dataNameGroup.push({ text: name,color: this.colorGroup[index] });
                        this.dataPieChart1.datasets[0].data.push(data_group_med.count);
                    })
                }).then(() => {
                    setTimeout(() => {
                        this.isLoading = false;
                        this.pieGroupLoaded = true;
                    }, 300);
                });
            },

            onclickSearchToolsPieChart() {
                this.isLoading = true;
                this.pieToolLoaded = false;
                let data_date = {
                    start_date: this.pieToolChartDateStart,
                    end_date: this.pieToolChartDateEnd,
                }
                this.dataPieChart2.labels = [];
                this.dataNameTools = [];
                this.dataPieChart2.datasets[0].data = [];
                // console.log('tool', data_date)
                Service.Common.getStatSearchDateTool(data_date).then(data => {
                    // console.log(data)
                    data.forEach((data_group, index) => {
                        this.dataPieChart2.labels.push(data_group.name_th)
                        let name = data_group.name_th.substring(0,30)+'...';
                        this.dataNameTools.push({ text: name,color: this.colorGroup[index] })
                        this.dataPieChart2.datasets[0].data.push(data_group.count)
                    });
                    setTimeout(() => {
                        this.isLoading = false;
                        this.pieToolLoaded = true;
                    },300)
                })
            }

        }
    }
</script>

<style lang="scss">
  .bar-chart {
    .v-input__control {
      min-height: auto !important;
      border-radius: 20px !important;
    }
  }
  .pie-chart {
    .square {
      width: 12px;
      height: 12px;
      margin-top: 2px;
    }
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: #527281;
    }
  }
</style>
